import styled, { CSSObject } from 'styled-components';

interface MenuItemStyledProps {
  selected?: boolean;
}

const MenuItemStyled = styled.div<MenuItemStyledProps>(
  ({ selected, theme }) => {
    let styleSheet: CSSObject = {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.font.family.primary,
      fontSize: theme.font.size.small,
      color: theme.color.wfBlack,
      background: theme.color.wfWhite,
      padding: `${theme.spacing.small} ${theme.spacing.small}`,
      boxSizing: 'border-box',
      '&:hover': {
        background: theme.color.wfGrey50,
      },
    };

    if (selected) {
      styleSheet = {
        ...styleSheet,
        color: theme.color.wfBlue,
        background: theme.color.wfGrey50,
      };
    }

    return styleSheet;
  },
);

export { MenuItemStyled };
